import { useDispatch, useSelector } from "react-redux";
import { useTheme } from "@mui/styles";
import { useTranslation } from "react-i18next";

import React from "react";
import BackgroundStepNumber from "../common/BackgroundStepNumber";
import BedBuilderHeader from "../common/BedBuilderHeader";
import BedBuilderNextButton from "../common/BedBuilderNextButton";
import FirmnessSlider from "./FirmnessSlider";

import {
  mattressConfigurationSelector,
  updateMattressConfiguration,
} from "../../../../redux/slices/mattressConfiguration";
import {
  metaFieldIdSelector,
  shopifyCustomerSelector,
} from "../../../../redux/slices/customer";
import { saveMattressConfigurationToLocalStorage } from "../../../../utils/bedBuilder.utils";
import {
  setCurrentStepSingleSleeperMattressBuilder,
  setIsSummaryModalOpen,
} from "../../../../redux/slices/customNavigation";

import styled from "styled-components";

const StyledContainer = styled.div`
  position: absolute;
  left: 0;
  top: 35%;
  width: 100%;
  height: 66%;
  overflow: auto;
`;

const StyledSettingsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 10%;
`;

const FirmnessSelector = ({ currentStepSingleSleeperMattressBuilder }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const dispatch = useDispatch();
  const shopifyCustomer = useSelector(shopifyCustomerSelector);
  const metaFieldId = useSelector(metaFieldIdSelector);
  const mattressConfiguration = useSelector(mattressConfigurationSelector);
  const handleUpdateMattressConfiguration = () => {
    const newMattressConfiguration = {
      metaFieldId: metaFieldId,
      id: shopifyCustomer.id,
      mattressConfiguration: mattressConfiguration,
    };
    dispatch(updateMattressConfiguration(newMattressConfiguration));
  };
  return (
    <>
      <StyledContainer style={{ zIndex: 500, overflow: "visible" }}>
        <BackgroundStepNumber>{t("4")}</BackgroundStepNumber>
      </StyledContainer>
      <StyledContainer style={{ zIndex: 600 }}>
        <StyledSettingsContainer className="mx-2">
          <BedBuilderHeader
            styles={{
              marginTop: "1rem",
              paddingRight: "20%",
              paddingLeft: "20%",
              textAlign: "center",
            }}
          >
            {t("Do you have a preference on the way your bed feels?")}
          </BedBuilderHeader>
          <FirmnessSlider></FirmnessSlider>

          <BedBuilderNextButton
            styles={{
              position: "absolute",
              bottom: "5%",
              right: "5%",
            }}
            onClick={() => {
              //Update in local storage
              // console.log("saving to local storage");
              saveMattressConfigurationToLocalStorage(mattressConfiguration);
              handleUpdateMattressConfiguration();
              dispatch(setIsSummaryModalOpen(true));
              dispatch(
                setCurrentStepSingleSleeperMattressBuilder(
                  currentStepSingleSleeperMattressBuilder + 1
                )
              );
            }}
          ></BedBuilderNextButton>
        </StyledSettingsContainer>
      </StyledContainer>
    </>
  );
};

export default FirmnessSelector;
